import { faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useEffect, useState } from 'react'
import { PRODUCT_MAP } from '../../../../constants/products'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { PRODUCT_CODE } from '../../../../utils/ENV'
import { toastError, toastSuccess } from '../../../../utils/toast'

const LimitedAccess = () => {
  const {
    isLoading,
    updateSetting,
    productsService,
    [SETTINGS.LIMITED_ACCESS.key]: limitedAccess
  } = useContext(SiteConfigContext)
  const [limitedAccessList, setLimitedAccessList] = useState(
    limitedAccess.list || ''
  )
  const [itemNumbers, setItemNumbers] = useState()
  const [unlimitedOnly, setUnlimitedOnly] = useState(
    !!limitedAccess.unlimitedOnly
  )
  const [unlimitedSubTypes, setUnlimitedSubTypes] = useState(
    limitedAccess.unlimitedSubTypes || ''
  )

  useEffect(() => {
    if (productsService) {
      const product = productsService[PRODUCT_MAP.THIS_PRODUCT]
      if (product) {
        setItemNumbers(
          product.access.itemNumbers ??
            (product.access.itemNumber
              ? [product.access.itemNumber]
              : [PRODUCT_CODE])
        )
      }
    }
  }, [productsService])

  useEffect(() => {
    setLimitedAccessList(limitedAccess.list || '')
    setUnlimitedOnly(!!limitedAccess.unlimitedOnly)
    setUnlimitedSubTypes(limitedAccess.unlimitedSubTypes || '')
  }, [limitedAccess])

  if (isLoading || !itemNumbers) {
    return (
      <h1 className="flex items-center">
        Loading...{' '}
        <FontAwesomeIcon
          icon={faSpinner}
          className="h-4 w-4 ml-2 animate-spin"
        />
      </h1>
    )
  }

  const handleAccess = async (e) => {
    e.preventDefault()
    const results =
      [
        ...new Set(
          limitedAccessList
            .split(',')
            .map((item) => item.replace(/[^A-Z0-9]/gi, '').toUpperCase())
            .filter((item) => itemNumbers.includes(item))
        )
      ].join(',') || PRODUCT_CODE
    const subTypes = [
      ...new Set(
        unlimitedSubTypes
          .split(',')
          .map((item) => item.replace(/[^A-Z0-9_-]/gi, '').toUpperCase())
          .filter(Boolean)
      )
    ].join(',')

    if (unlimitedOnly && !subTypes) {
      toastError(
        'Add at least one Unlimited sub type or uncheck Unlimited Only.'
      )
      return
    }

    setLimitedAccessList(results)
    setUnlimitedSubTypes(subTypes)

    await updateSetting(SETTINGS.LIMITED_ACCESS, {
      ...limitedAccess,
      list: results,
      unlimitedOnly,
      unlimitedSubTypes: subTypes
    })
    toastSuccess('Stream Access updated.')
  }

  return (
    <div className="flex flex-col gap-2">
      <h2>Set Limited Access</h2>
      <h3 className="mr-3">Item Number Options: {itemNumbers.toString()}</h3>
      <form onSubmit={handleAccess} autoComplete="off">
        <div className="relative flex flex-grow items-stretch focus-within:z-10 gap-2">
          <input
            value={limitedAccessList}
            onChange={(e) => setLimitedAccessList(e.target.value)}
            className="input block w-full"
            placeholder="Limited Access"
            maxLength={50}
          />
          <button
            type="submit"
            aria-label="Submit title"
            className="button-confirm inline-flex items-center gap-x-1.5 text-base"
          >
            Save
          </button>
        </div>
        <div className="mt-3 flex items-center">
          <input
            id="unlimitedOnly"
            type="checkbox"
            checked={unlimitedOnly}
            onChange={(e) => setUnlimitedOnly(e.target.checked)}
            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
          />
          <label
            htmlFor="unlimitedOnly"
            className="flex gap-2 items-center dark:text-neutral-50"
          >
            Unlimited Only
          </label>
        </div>
        {unlimitedOnly && (
          <div className="mt-2 flex flex-col gap-1">
            <h3>Unlimited Sub Types</h3>
            <input
              value={unlimitedSubTypes}
              onChange={(e) => setUnlimitedSubTypes(e.target.value)}
              className="input block w-full"
              placeholder="Unlimited Sub Types"
              maxLength={100}
            />
          </div>
        )}
      </form>
    </div>
  )
}

export default LimitedAccess
